import { toastr } from "react-redux-toastr";
import { Label, ModalUpload, Button as ExpanoButton } from "expano-components";
import { Button, MainList, Main } from "components";
import { client, getApiErrorMessage } from "utils/api";

import { ReactComponent as ShopIcon } from "icons/shop.svg";
import { useState } from "react";

import { sort, filters } from "./const/data";
import { getKindLabel } from "utils/select_options/product_kind_options";
import LazyLoad from "react-lazy-load";
import CreateProductGroupsFromCsvModal from "./components/CreateProductGroupsFromCsvModal";

const ProductGroupList = ({ history }) => {
  const [is_open_upload_modal, setOpenUploadModal] = useState(false);
  const [create_product_group_modal_data, setCreateProductGroupModalData] =
    useState(null);

  const handleUpload = async (file) => {
    try {
      const body = new FormData();
      body.append("file", file);
      const data = await client.post(`/product_groups/preimport_csv`, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setCreateProductGroupModalData(data);
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    }
  };

  return (
    <Main
      page={{
        name: "Produkty grupowe",
        icon: <ShopIcon />,
        breadcrumbs: [
          {
            name: "Produkty grupowe",
          },
        ],
        buttons: (
          <>
            <ExpanoButton
              onClick={() => setOpenUploadModal(true)}
              text="Dodaj produkty grupowe (.csv)"
            />
            <Button
              type="add"
              text="Dodaj produkt grupowy"
              path="/product_groups/new"
            />
          </>
        ),
      }}
    >
      {create_product_group_modal_data && (
        <CreateProductGroupsFromCsvModal
          {...create_product_group_modal_data}
          handleClose={() => setCreateProductGroupModalData(null)}
        />
      )}
      {is_open_upload_modal && (
        <ModalUpload
          headerText="Wgraj plik (.csv)"
          handleUpload={handleUpload}
          accept=".csv"
          handleClose={() => setOpenUploadModal(false)}
        />
      )}
      <MainList
        query_key="product_groups"
        api_path="/product_groups"
        sort_column="id"
        sort_direction="desc"
        context="ui_index"
        sort={sort}
        filters={filters}
        handleNavigate={(item) => history.push(`/product_groups/${item.id}`)}
        renderItem={({
          name,
          sku,
          kind,
          global_image_url,
          root_taxon,
          producer,
          brand,
          channels,
          cn_code,
          ai_cn_confidence,
          ai_cn_source,
        }) => (
          <>
            <td>
              {global_image_url && (
                <LazyLoad height={40}>
                  <img
                    alt={name}
                    src={global_image_url}
                    style={{
                      width: 40,
                      height: 40,
                    }}
                  />
                </LazyLoad>
              )}
            </td>
            <td>{name}</td>
            <td>{sku}</td>
            <td>{getKindLabel(kind)}</td>
            <td>{root_taxon?.name}</td>
            <td>{producer?.name}</td>
            <td>{brand?.name}</td>
            <td>
              {cn_code ? (
                <span title={ai_cn_source ? `źródło: ${ai_cn_source}` : undefined}>
                  {cn_code}
                  {ai_cn_confidence != null &&
                    ai_cn_source !== "manual" &&
                    ` (${Math.round(ai_cn_confidence * 100)}%)`}
                </span>
              ) : (
                <span style={{ color: "#fd397a" }}>brak</span>
              )}
            </td>
            <td>
              <div style={{ display: "flex", gap: "13px 0", flexFlow: "wrap" }}>
                {channels
                  ?.sort((a, b) => a.id - b.id)
                  ?.map(({ id, shop, platform }) => (
                    <span key={id} style={{ whiteSpace: "nowrap" }}>
                      <Label
                        type="double"
                        left={{
                          text: shop?.label_text,
                          color: `#${shop?.label_color}`,
                        }}
                        right={{
                          text: platform?.label_text,
                          color: `#${platform?.label_color}`,
                        }}
                      />
                    </span>
                  ))}
              </div>
            </td>
          </>
        )}
      />
    </Main>
  );
};

export default ProductGroupList;
